import { Locales, Column } from "@simplyk/common";
import { UseFormSetValue } from "react-hook-form";

import { useTranslateRows } from "../helpers/useTranslateRows";
import { DonationTranslationsData } from "../translation.types";

import { DonationFormWithUserAmountOutput } from "@/common/types/trpc";

export function useTranslateAmounts({
  amounts,
  translationLocale,
  setValue,
  existingTranslations,
}: {
  amounts: Array<DonationFormWithUserAmountOutput & { destinationIndex?: number }>;
  translationLocale: Locales;
  setValue: UseFormSetValue<DonationTranslationsData>;
  existingTranslations?: ReadonlyArray<{ message?: string | null } | undefined>;
}) {
  const { isTranslating, translatedIds } = useTranslateRows<DonationTranslationsData>({
    translationLocale,
    setValue: (path, value) => setValue(path as `translations.donationFormAmounts.${number}.message`, value),
    rows: amounts.map((amount, index) => {
      const destinationIndex = amount.destinationIndex ?? index;
      return {
        id: amount.id,
        fields: [
          {
            key: "message",
            path: `${Column.Translations}.donationFormAmounts.${destinationIndex}.message`,
            source: amount.message ?? "",
            saved: existingTranslations?.[destinationIndex]?.message,
            isPlainText: true,
          },
        ],
      };
    }),
  });

  return { isTranslating, translatedAmountIds: translatedIds };
}
